import type { ButtonProps } from "@jobteaser/spark/components/Button/Button"
import type { FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { Button } from "@jobteaser/spark/components/Button"
import { Text } from "@jobteaser/spark/components/Text"

import styles from "./FilterButton.module.css"

type FilterButtonProps = PropsWithChildren<ButtonProps & { isActive: boolean; counter?: number | null }>

export const FilterButton: FunctionComponent<FilterButtonProps> = ({
  children,
  className,
  counter = null,
  isActive,
  ...props
}) => (
  <Button
    className={clsx(className, styles.button, {
      [styles.button___active]: isActive,
    })}
    onBackground="dark"
    variant="tertiary"
    {...props}
  >
    <span className={styles.button__content}>
      {children}
      {counter && (
        <Text className={styles.button__counter} variant="body2" as="span">
          {counter}
        </Text>
      )}
    </span>
  </Button>
)
